export default {
  'RECIPE_FROM_STATUS_REMOVE':'RECIPE_FROM_STATUS_REMOVE',
  'RECIPE_FROM_STATUS_DISPLAY':'RECIPE_FROM_STATUS_DISPLAY',
};


// WEBPACK FOOTER //
// ./modules/recipe_form/constants/StatusConstants.js